import Font1 from '@/assets/fonts/quincy/QuincyCF-Regular.woff2';
import Font2 from '@/assets/fonts/quincy/QuincyCF-Bold.woff2';

export default [
  {
    "family": "Quincy",
    "locals": [
      "Quincy CF"
    ],
    "fallback": [
      "ui-serif",
      "Georgia",
      "Cambria",
      "\"Times New Roman\"",
      "Times",
      "serif"
    ],
    "variances": [
      {
        "style": "normal",
        "weight": 400,
        "sources": [
          {
            "src": "@/assets/fonts/quincy/QuincyCF-Regular.woff2",
            "type": "woff2"
          }
        ],
        "src": Font1,
        "type": "woff2"
      },
      {
        "style": "normal",
        "weight": 700,
        "sources": [
          {
            "src": "@/assets/fonts/quincy/QuincyCF-Bold.woff2",
            "type": "woff2"
          }
        ],
        "src": Font2,
        "type": "woff2"
      }
    ]
  }
];